module.exports = __webpack_public_path__ + "static/media/unKnownDealer.4f768615.jpg";